<template>
    <el-select v-model="newValue" @change="input" size="small">
        <el-option v-for="(item, index) in listData" :label="item.name" :key="index" :value="item.keyId"></el-option>
    </el-select>
</template>
<script>
    export default {
        props:{
            enumKey: {
                type: String,
                required: true
            },
            value: {
                type: Number
            },
            mergeLists: {
                type: Array,
                default: function() {
                    return [ ]
                }
            }
        },
        data(){
            return {
                newValue: '',
                listData: [],
            }
        },
        watch: {
            value(val){
                this.newValue = val
                console.log(val)
            },
            enumKey(){
                this.getSystemEnums()
            },
        },
        mounted(){
            this.newValue = this.value
            this.getSystemEnums()
        },
        methods: {
            getSystemEnums() {
                if(this.enumKey){
                    if(this.$store.state.dictsMap && this.$store.state.dictsMap[this.enumKey]){
                        this.listData =this.mergeLists.concat(this.$store.state.dictsMap[this.enumKey])  
                    }else{
                        this.$request.post('/system/getSystemEnums', {
                            keys: [this.enumKey]
                        }).then(res => {
                            this.$store.commit('setDictsMap',{
                                key: this.enumKey,
                                data:  res.data
                            })
                            this.listData =this.mergeLists.concat(res.data)
                        })
                    }
                }
            },
            input(val){
                if(val){
                    this.$emit('input',val)
                    var rowQuery = this.listData.filter((item) => {
                        return item.keyId == val
                    })
                    this.$emit('select',rowQuery[0])
                }else{
                    this.$emit('input',0)
                }
            }
        }
    }
</script>
<style lang="scss" scoped>
    ::v-deep.el-radio-button__inner{
        border: 1px solid #0D68FF !important;
        color: #0D68FF !important;
    }
    ::v-deep.el-radio-button__orig-radio:checked+.el-radio-button__inner{
        background-color: #0D68FF;
    }
</style>
